import { Draggable } from '@hello-pangea/dnd';
import { cloneElement, forwardRef, PropsWithChildren, ReactElement } from 'react';

import { SortableItemContext } from './SortableItemHandle';

interface Props {
	id: string;
	index: number;
	disabled?: boolean;
	asHandle?: boolean;
}

const SortableItem = forwardRef<HTMLElement, PropsWithChildren<Props>>(
	({ id, index, disabled = false, asHandle = false, children }, _ref) => {
		return (
			<Draggable draggableId={id} index={index} isDragDisabled={disabled}>
				{(provided, snapshot) => (
					<SortableItemContext.Provider
						value={{
							dragHandleProps: provided.dragHandleProps,
							isDragging: snapshot.isDragging,
						}}
					>
						{cloneElement(children as ReactElement, {
							ref: provided.innerRef,
							...(!disabled && provided.draggableProps),
							...(asHandle && provided.dragHandleProps),
						})}
					</SortableItemContext.Provider>
				)}
			</Draggable>
		);
	}
);

SortableItem.displayName = 'SortableItem';

export { SortableItem };
